import { CategoryTilesSection } from '@/modules/external/components/customer/overview/category-tiles-section.component';
import { FeaturedArticlesSection } from '@/modules/external/components/customer/overview/featured-articles-section.component';
import { HeroSection } from '@/modules/external/components/customer/overview/hero-section.component';
import { RecentOrdersSection } from '@/modules/external/components/customer/overview/recent-orders-section.component';
import { ResourcesSection } from '@/modules/external/components/customer/overview/resources-section.component';
import { StaggerFadeIn } from '@/modules/external/components/customer/overview/stagger-fade-in.component';
import Container from '@components/base/container.component';
import { Box, Stack } from '@mui/material';

export function ExternalOverviewPage() {
  return (
    <Box>
      <StaggerFadeIn delay={0}>
        <HeroSection />
      </StaggerFadeIn>

      <Container maxWidth="lg" sx={{ px: 0 }}>
        <Stack spacing={4} sx={{ mt: 4 }}>
          <StaggerFadeIn delay={100}>
            <CategoryTilesSection />
          </StaggerFadeIn>

          <StaggerFadeIn delay={200}>
            <FeaturedArticlesSection />
          </StaggerFadeIn>

          <StaggerFadeIn delay={300}>
            <ResourcesSection />
          </StaggerFadeIn>

          <StaggerFadeIn delay={400}>
            <RecentOrdersSection />
          </StaggerFadeIn>
        </Stack>
      </Container>
    </Box>
  );
}
